/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Activity_Eta_HoursInputs */



/**
* | output |
* | --- |
* | "~{count}h remaining" |
*
* @param {Activity_Eta_HoursInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_eta_hours = /** @type {((inputs: Activity_Eta_HoursInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Eta_HoursInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`~${i?.count} Std. verbleibend`)
	return /** @type {LocalizedString} */ (`~${i?.count}h remaining`)
});